import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
// import 'bootstrap/dist/css/bootstrap.min.css';
import '@/main.scss';
import VueQuagga from 'vue-quaggajs';
// import * as firebase from 'firebase';
import Notifications from 'vue-notification';
import Vuex from 'vuex';
import { store } from './store';
import './helper/filter';

Vue.config.productionTip = false;
Vue.use(Vuex);
Vue.use(VueQuagga);
Vue.use(Notifications);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
// Notification.requestPermission(function(status) {
//   console.log('Notification permission status:', status);
// });

window.isUpdateAvailable = new Promise(function(resolve) {
  navigator.serviceWorker
    .register('service-worker.js')
    .then(reg => {
      reg.onupdatefound = () => {
        const installingWorker = reg.installing;
        installingWorker.onstatechange = () => {
          switch (installingWorker.state) {
            case 'installed':
              if (navigator.serviceWorker.controller) {
                resolve(true);
              } else {
                // no update available
                resolve(false);
              }
              break;
          }
        };
      };
    })
    .catch(err => console.error('[SW ERROR]', err));
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
